
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';


import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/common-3.0.css';
import './assets/css/common.css';

/* eslint-disable */
import common from './assets/js';//定义公共js文件
Vue.use(common);

// 定义全局组件
Vue.prototype.$axios = axios;
axios.defaults.timeout = '200000';
Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.prototype.apiTp5Url = 'http://ezhidao.net/admin2/api';

// Vue.prototype.apiTp5Url = 'http://laravel54.com/admin2/api';


import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)


import * as filters from './filter' // global filters
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
